import superagentInterface from 'redux-query-interface-superagent';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectRequest as rqConnectRequest } from 'redux-query-react';
import { errorSelectors, querySelectors } from 'redux-query';

import {
  getErrors,
  getQueries,
  selectAffiliatesUrl,
  selectCloudPayUrl,
  selectContentProvider,
  selectDisneyCrmUrl,
  selectServiceConfig,
  selectStatusUrl,
  selectUnityUrl,
} from '../global-selectors';

import {
  selectUserData
} from '../queries/selectors/user';

export const proxyInterface = (url, method, options) => (
  superagentInterface(url, method, options)
);

export const isLoading = (state, props, mapPropsToConfigs) => {
  return mapPropsToConfigs(props).some(
    queryConfig => (
      querySelectors.isPending(getQueries(state), queryConfig) &&
      querySelectors.status(getQueries(state), queryConfig) < 400
    )
  );
};

export const getStatus = (state, queryConfig) => {
  return querySelectors.status(getQueries(state), queryConfig);
};

export const getError = (state, queryConfig) => {
  return errorSelectors.responseBody(getErrors(state), queryConfig);
};

export const findQueryByRouteMatch = (queries, search) => Object.entries(queries)
  .find(([key]) => {
    const url = (JSON.parse(key) || {}).url;
    return url.includes(search);
  });

export const findLastQueryByRouteMatch = (queries, search) => Object.entries(queries)
  .reverse()
  .find(([key]) => {
    const url = (JSON.parse(key) || {}).url;
    return url.includes(search);
  });

export const connectRequest = mapPropsToConfig => {
  const mapStateToProps = (state) => ({
    serviceConfig: selectServiceConfig(state),
    user: selectUserData(state)
  });

  const mapQueryStateToProps = (state, props) => ({
    isLoading: isLoading(state, props, mapPropsToConfig),
    errors: mapPropsToConfig(props)
      .reduce((acc, config) => ({
        ...acc,
        [config.url]: getError(state, config)
      }), {})
  });

  return compose(
    connect(mapStateToProps),
    connect(mapQueryStateToProps),
    rqConnectRequest(mapPropsToConfig)
  );
};

export const getHeaders = (props) => {
  const { user = {} } = props;

  if (user.token) {
    return {
      Authorization: `Bearer ${user.token}`
    };
  }
};

export const buildUnityQuery = (builder) => (
  (props = {}) => {
    const { serviceConfig } = props;
    const url = selectUnityUrl(serviceConfig);
    const headers = getHeaders(props);
    const query = builder(props);

    return {
      ...query,
      url: `${url}${query.url || ''}`,
      options: {
        ...query.options,
        headers
      }
    };
  }
);

export const buildCloudPayQuery = (builder) => (
  (props = {}) => {
    const { serviceConfig } = props;
    const url = selectCloudPayUrl(serviceConfig);
    const headers = getHeaders(props);
    const query = builder(props);

    return {
      ...query,
      url: `${url}${query.url || ''}`,
      options: {
        ...query.options,
        headers: { ...headers, 'Access-Control-Allow-Origin': '*' }
      }
    };
  }
);

export const buildDisneyCrmQuery = (builder) => (
  (props = {}) => {
    const { serviceConfig } = props;
    const url = selectDisneyCrmUrl(serviceConfig);
    const headers = getHeaders(props);
    const query = builder(props);

    return {
      ...query,
      url: `${url}${query.url || ''}`,
      options: {
        ...query.options,
        headers: { ...headers, 'Access-Control-Allow-Origin': '*' }
      }
    };
  }
);

export const buildStatusQuery = (builder) => (
  (props = {}) => {
    const { serviceConfig } = props;
    const url = selectStatusUrl(serviceConfig);
    const query = builder(props);

    return {
      ...query,
      url: `${url}${query.url || ''}`
    };
  }
);

export const buildMsoConfigQuery = (builder) => (state) => {
  const cp = selectContentProvider(state)
  // TODO: Retrieve value with a selector from env vars
  const url = `${window.AppENV.pass.baseURL}/auth/${cp}/mso.json`;
  const query = builder(state);

  return {
    ...query,
    url: `${url}${query.url || ''}`,
  };
}

export const buildAffiliatesQuery = builder => (state = {}) => {
  const url = selectAffiliatesUrl(state);
  const query = builder(state);

  if (!url) {
    console.error('[buildAffiliatesQuery] La URL de affiliates no está configurada en serviceConfig.affiliates.baseURL');
    // Retornar una query que fallará de manera controlada
    return {
      ...query,
      url: '',
      options: {
        ...query.options,
        // Esto causará un error controlado en lugar de una URL inválida
      }
    };
  }

  return {
    ...query,
    url: `${url}${query.url || ''}`,
  }
}

export const buildAffiliatesMutation = mutationBuilder => (payload = null, state = {}) => {
  const url = selectAffiliatesUrl(state);
  const query = mutationBuilder(payload, state);

  return {
    ...query,
    url: `${url}${query.url || ''}`,
  }
}
